export default __webpack_public_path__ + "static/media/power8.ea3c7d8a.svg";